(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-custom"] && !window.DesignMode) return;
  try {
    
  function openLoginPopup(url) {
    var width = 500;
    var height = 700;
    var left = (window.innerWidth - width) / 2;
    var top = (window.innerHeight - height) / 2;
    
    var features = 
      'width=' + width + 
      ',height=' + height + 
      ',left=' + left + 
      ',top=' + top + 
      ',resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,status=no';
    
    window.open(url, 'shopifyLogin', features);
    return false;
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      // Set up menu item click events
      this.setupMenuItemClickEvents();
      // Set up search modal toggle listener
      this.setupSearchModalListener();
    }

    setupSearchModalListener() {
      const searchDetailsModal = this.header.querySelector('details-modal.header__search');
      if (searchDetailsModal) {
        const detailsElement = searchDetailsModal.querySelector('details');
        if (detailsElement) {
          // The element that has the .header__icon--search class and needs styling
          const iconElementToStyle = detailsElement.querySelector('.header__icon--search');

          if (iconElementToStyle) {
            detailsElement.addEventListener('toggle', (event) => {
              if (event.target.open) {
                iconElementToStyle.classList.add('active');
              } else {
                iconElementToStyle.classList.remove('active');
              }
            });
          }
        }
      }
    }

    setupMobileMenuListener() {
      const menuDrawerContainer = document.querySelector('#Details-menu-drawer-container');
      const menuIcon = document.querySelector('.header__icon--menu');
      
      if (menuDrawerContainer && menuIcon) {
        menuDrawerContainer.addEventListener('toggle', (event) => {
          if (event.target.open) {
            menuIcon.classList.add('active');
          } else {
            menuIcon.classList.remove('active');
          }
        });
      }
    }

    setupMenuItemClickEvents() {
      const menuItems = document.querySelectorAll('.header__menu-item');
      const icons = document.querySelectorAll('.header__icon');
      const activeClass = 'header__active-menu-item';

      this.setActiveMenuItem(menuItems, icons, activeClass);
      
      // Set up mobile menu listener
      this.setupMobileMenuListener();
      
      menuItems.forEach(item => {
        item.addEventListener('click', () => {
          menuItems.forEach(otherItem => otherItem.classList.remove(activeClass));
          item.classList.add(activeClass);
          
          const link = item.querySelector('a');
          if (link && link.getAttribute('href')) {
            localStorage.setItem('activeMenuPath', link.getAttribute('href'));
          }
        });
      });
      
      icons.forEach(icon => {
        // Don't add click handler to menu icon - it's handled by the setupMobileMenuListener
        if (!icon.classList.contains('header__icon--menu')) {
          icon.addEventListener('click', () => {
            icons.forEach(otherIcon => {
              if (!otherIcon.classList.contains('header__icon--menu')) {
                otherIcon.classList.remove('active');
              }
            });
            icon.classList.add('active');
          });
        }
      });
    }
    
    setActiveMenuItem(menuItems, icons, activeClass) {
      const menuActiveClass = 'header__active-menu-item';
      const iconCurrentPageClass = 'header__icon--current-page';
      const currentPath = window.location.pathname;
      const storedActivePath = localStorage.getItem('activeMenuPath');

      menuItems.forEach(item => item.classList.remove(menuActiveClass));
      
      let activeSet = false;
      menuItems.forEach(item => {
        const link = item.querySelector('a');
        if (link) {
          const href = link.getAttribute('href');
          if (href) {
            if (href === currentPath ||
                (href !== '/' && currentPath.startsWith(href + (href.endsWith('/') ? '' : '/'))) ||
                (storedActivePath && href === storedActivePath && storedActivePath === currentPath)) {
              item.classList.add(menuActiveClass);
              activeSet = true;
              if (href === currentPath || (storedActivePath && href === storedActivePath && storedActivePath === currentPath) ) {
                localStorage.setItem('activeMenuPath', href);
              }
            }
          }
        }
      });
      
      if (!activeSet && storedActivePath === currentPath) {
        menuItems.forEach(item => {
          const link = item.querySelector('a');
          if (link && link.getAttribute('href') === storedActivePath) {
            item.classList.add(menuActiveClass);
            activeSet = true;
          }
        });
      }

      if (storedActivePath && storedActivePath !== currentPath && !currentPath.startsWith(storedActivePath + (storedActivePath.endsWith('/') ? '' : '/'))) {
         if (currentPath !== '/' && !storedActivePath.startsWith(currentPath + (currentPath.endsWith('/') ? '' : '/'))) {
            localStorage.removeItem('activeMenuPath');
         }
      }

      const allHeaderIcons = document.querySelectorAll('.header__icon');
      allHeaderIcons.forEach(icon => icon.classList.remove(iconCurrentPageClass));

      allHeaderIcons.forEach(icon => {
        const href = icon.getAttribute('href');
        if (href && href !== '#') {
          let iconPath = href.split('?')[0];
          if (iconPath.endsWith('/') && iconPath !== '/') {
            iconPath = iconPath.slice(0, -1);
          }
          let currentBasePath = currentPath.split('?')[0];
          if (currentBasePath.endsWith('/') && currentBasePath !== '/') {
            currentBasePath = currentBasePath.slice(0, -1);
          }

          if (iconPath === currentBasePath || (iconPath !== '/' && currentBasePath.startsWith(iconPath + '/'))) {
            icon.classList.add(iconCurrentPageClass);
          }
        }
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  // Initialize active menu item on page load
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeaderInstance = document.querySelector('sticky-header');
    if (stickyHeaderInstance && typeof stickyHeaderInstance.setActiveMenuItem === 'function') {
      const menuItems = document.querySelectorAll('.header__menu-item');
      stickyHeaderInstance.setActiveMenuItem(menuItems, null, 'header__active-menu-item');
    } else {
      // Fallback or log error if custom element or method not found
      console.warn('StickyHeader or setActiveMenuItem not ready on DOMContentLoaded');
      // Basic fallback if needed, though ideally the custom element handles it
      const currentPath = window.location.pathname;
      const menuItems = document.querySelectorAll('.header__menu-item');
      const storedActivePath = localStorage.getItem('activeMenuPath');
      const activeClass = 'header__active-menu-item';

      let activeSet = false;
      menuItems.forEach(item => {
        const link = item.querySelector('a');
        if (link) {
          const href = link.getAttribute('href');
          if (href && (href === currentPath || (href !== '/' && currentPath.startsWith(href + (href.endsWith('/') ? '' : '/'))))) {
            item.classList.add(activeClass);
            activeSet = true;
            localStorage.setItem('activeMenuPath', href);
          }
        }
      });
      if (!activeSet && storedActivePath === currentPath) {
        menuItems.forEach(item => {
          const link = item.querySelector('a');
          if (link && link.getAttribute('href') === storedActivePath) {
            item.classList.add(activeClass);
          }
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
